import React, { useState } from 'react';

function Sidebar({ currentPage, onNavigate, onLogout, adminUser, collapsed, onToggleCollapse }) {
  const [expandedSections, setExpandedSections] = useState({
    users: false,
    content: false,
    reports: false,
    logs: false,
    announcements: false,
    stats: false, // Issue #291: Statistiken submenu
    beta: false, // Issue #359: Beta test data
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const menuItems = [
    {
      id: 'stats',
      label: 'Statistiken',
      icon: '📊',
      expandable: true,
      children: [
        { id: 'dashboard', label: 'Übersicht', onClick: () => onNavigate('dashboard') },
        { id: 'userEngagement', label: 'User Engagement', onClick: () => onNavigate('userEngagement') },
        { id: 'revenue', label: 'Umsatz', onClick: () => onNavigate('revenue') },
      ],
    },
    {
      id: 'users',
      label: 'Benutzerkontoverwaltung',
      icon: '👥',
      expandable: true,
      children: [
        { id: 'users', label: 'Alle Benutzer', onClick: () => onNavigate('users') },
      ],
    },
    {
      id: 'content',
      label: 'Contentsverwaltung',
      icon: '📝',
      expandable: true,
      children: [
        { id: 'posts', label: 'Beiträge', onClick: () => onNavigate('posts') },
        { id: 'marketplace', label: 'Marktplatzobjekte', onClick: () => onNavigate('marketplace') },
        { id: 'comments', label: 'Kommentare', onClick: () => onNavigate('comments') },
      ],
    },
    {
      id: 'courses',
      label: 'Kursverwaltung',
      icon: '📚',
      onClick: () => onNavigate('courses'),
    },
    {
      id: 'reports',
      label: 'Reports',
      icon: '🚨',
      onClick: () => onNavigate('reports'),
    },
    {
      id: 'logs',
      label: 'Logs',
      icon: '📋',
      onClick: () => onNavigate('logs'),
    },
    {
      id: 'announcements',
      label: 'Ankündigungen',
      icon: '📢',
      onClick: () => onNavigate('announcements'),
    },
    {
      id: 'feedback',
      label: 'Feedback',
      icon: '💬',
      onClick: () => onNavigate('feedback'),
    },
    {
      id: 'monitoring',
      label: 'Monitoring',
      icon: '📡',
      onClick: () => onNavigate('monitoring'),
    },
    {
      id: 'backups',
      label: 'Sichern & Wiederherstellen',
      icon: '💾',
      onClick: () => onNavigate('backups'),
    },
    {
      id: 'beta',
      label: 'Beta',
      icon: '🧪',
      expandable: true,
      children: [
        { id: 'betaScheduled', label: 'Testdaten hochladen', onClick: () => onNavigate('betaScheduled') },
        { id: 'betaUploaded', label: 'Hochgeladene Testdaten', onClick: () => onNavigate('betaUploaded') },
        // Issue #366: Star rating results
        { id: 'betaRatings', label: 'Sternebewertung', onClick: () => onNavigate('betaRatings') },
      ],
    },
    {
      id: 'settings',
      label: 'Einstellungen',
      icon: '⚙️',
      onClick: () => onNavigate('settings'),
    },
  ];

  return (
    <aside className={`admin-sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img src="/logo.png" alt="" className="sidebar-logo-img" />
          {!collapsed && <span className="sidebar-title">UNIVERSE ADMIN</span>}
        </div>
      </div>

      <button className="sidebar-toggle" onClick={onToggleCollapse}>
        <span className="hamburger-icon">☰</span>
        {!collapsed && <span>Menu</span>}
      </button>

      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <div key={item.id} className="nav-item-container">
            <button
              className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
              onClick={() => {
                if (item.expandable) {
                  toggleSection(item.id);
                } else if (item.onClick) {
                  item.onClick();
                }
              }}
            >
              <span className="nav-icon">{item.icon}</span>
              {!collapsed && (
                <>
                  <span className="nav-label">{item.label}</span>
                  {item.expandable && (
                    <span className={`nav-arrow ${expandedSections[item.id] ? 'expanded' : ''}`}>
                      ▼
                    </span>
                  )}
                </>
              )}
            </button>
            {item.expandable && expandedSections[item.id] && !collapsed && (
              <div className="nav-children">
                {item.children.map((child) => (
                  <button
                    key={child.id}
                    className={`nav-child-item ${currentPage === child.id ? 'active' : ''}`}
                    onClick={child.onClick}
                  >
                    {child.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        {!collapsed && adminUser && (
          <div className="admin-info">
            <span className="admin-name">{adminUser.username}</span>
            <span className="admin-role">{adminUser.role}</span>
          </div>
        )}
        <button className="logout-button" onClick={onLogout}>
          🚪 {!collapsed && 'Abmelden'}
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
